import React, { useEffect } from "react";
import PropTypes from "prop-types";
import * as PageResponsive from "components/utility/page-responsive/PageResponsive";

const SearchCallToActionBarContent = ({ data }) => {
	const { text = "", link = "", linkText = "" } = data ? data : {};

	useEffect(() => {
		window.addEventListener("load", moveToTop);
		window.addEventListener("resize", moveToTop);
		moveToTop();
	});
	const moveToTop = () => {
		const searchBanner = document.querySelector(".search-call-to-action-bar");
		const searchHeaderHolder = document.querySelector(".search-page-header");
		const searchHeaderMobileHolder = document.querySelector(".search-page-header-container");
		if (searchHeaderHolder && text) {
			if (PageResponsive.isMobile()) {
				searchHeaderMobileHolder.insertAdjacentElement("afterend", searchBanner);
			} else {
				searchHeaderHolder.insertAdjacentElement("afterend", searchBanner);
			}
		}
	};
	return text ? (
		<div className="container search-call-to-action-bar">
			<div className="grid-center">
				<div className="col-8_sm-12 search-call-to-action-bar-zero-padding" data-testid="padding">
					<p className="body-3-left-white">{text}</p>
				</div>
				<div
					className="col-4_sm-12 search-call-to-action-bar-zero-padding search-call-to-action-bar-link"
					data-testid="link"
				>
					<a href={link}>{linkText}</a>
				</div>
			</div>
		</div>
	) : null;
};

SearchCallToActionBarContent.propTypes = {
	data: PropTypes.shape({
		text: PropTypes.string,
		link: PropTypes.string.isRequired,
		linkText: PropTypes.string
	})
};

export default SearchCallToActionBarContent;
